import { TableSortLabel } from '@mui/material'
import { Column } from '@tanstack/react-table'

import { Earning, EarningRide } from '../../types/interfaces'

interface Props {
  column: Column<Earning, unknown> | Column<EarningRide, unknown>
  label: string
  onSort: (sort: Record<string, string>) => void
}

export const SortableTaleHeader = ({ column, label, onSort }: Props) => {
  const sortDirection = column?.getIsSorted()

  return (
    <TableSortLabel
      active={!!sortDirection}
      direction={sortDirection || 'asc'}
      onClick={() => {
        column?.toggleSorting(sortDirection === 'asc')
        onSort({ [column.id]: sortDirection === 'asc' ? 'desc' : 'asc' })
      }}
    >
      {label}
    </TableSortLabel>
  )
}
